export enum CartStatus {
  Null = "null",
  Empty = "empty",
  Ready = "ready",
  Pending = "pending",
}

export type DashboardOrderDetailsGridData = {
  annotatedCartStatus: CartStatus;
  orderLinesStatus: CartStatus;
  zoneBasedPredictionStatus: CartStatus;
  pinBasedPredictionStatus: CartStatus;
  uniqueLines: {
    updatedAt: string | undefined;
    orderLine?: {
      quantity: number;
      sku_base_id: number;
      name: string;
      barcode: string;
      variant_id: string;
      image_url: string;
      uom: string;
    };
    annotatedLine?: {
      quantity: number;
      sku_base_id: number;
      name: string;
      barcode: string;
      variant_id: string;
      image_url: string;
      uom: string;
    };
    zoneBasedPredictionLine?: {
      quantity: number;
      sku_base_id: number;
      name: string;
      barcode: string;
      variant_id: string;
      image_url: string;
      uom: string;
    };
    pinBasedPredictionLine?: {
      quantity: number;
      sku_base_id: number;
      name: string;
      barcode: string;
      variant_id: string;
      image_url: string;
      uom: string;
    };
  }[];
};

export enum CartSegment {
  Annotated = "annotated",
  OrderLines = "order-lines",
}
